import React from "react";

export default function DateLine({ description, date, before, endDate }) {
  // Format the date display based on the presence of preposition and endDate
  const formatDateDisplay = () => {
    if (date && endDate) {
      return `du ${date} au ${endDate}`;
    } else if (before && date) {
      return `avant le ${date}`;
    } else if (date) {
      return `${date}`;
    } else {
      return ''
    }
  };

  const ariaLabel = `${description}: ${formatDateDisplay()}`;

  return (
    <div className="text-white flex items-center justify-between my-1 border-b border-white border-opacity-20" aria-label={ariaLabel}>
      <div className="text-xs sm:text-sm">{description}</div>
      <div className="font-semibold text-xs sm:text-sm" aria-hidden="true">
        {formatDateDisplay()}
      </div>
    </div>
  );
}
